export class AusmashDateQuery {
    constructor(params = {}) {
        this.startDate = params === null || params === void 0 ? void 0 : params.startDate;
        this.endDate = params === null || params === void 0 ? void 0 : params.endDate;
    }
}
AusmashDateQuery.toQueryString = (query) => {
    if (query == null || query.startDate == null && query.endDate == null) {
        return "";
    }
    const url = new URLSearchParams();
    if (query.startDate) {
        url.append("startDate", query.startDate.toDateString());
    }
    if (query.endDate) {
        url.append("endDate", query.endDate.toDateString());
    }
    return `?${url.toString()}`;
};
